// 创建文件en/index.js
const en = {
    rejected: "Rejected",
    my: "My",
    today: "Today",
    this_week: "This Week",
    this_month: "This Month",
    last_month: "Last Month",
    this_year: "This Year",
    number_of_people: "Number of People",
    amount: "Amount",
    enter_username_id_to_search: "Enter Username ID to Search",
    team_list: "Team List",
    registration_time: "Registration Date",
    selling_face_value: "Selling Face Value",
    click_for_details: "Click for Details",
    "agent_login": "Agent Login",
    'SignOut': 'Delete Account',
    'Contact us': 'Contact us',
    'Download our app': 'Download our app',
    'Download it from': 'Download it from',
    'About Us': 'About Us',
    'Gobuy USA was founded in 2012': 'Gobuy USA was founded in 2012',
    'Customer service': 'Customer service',
    'frequently asked question': 'frequently asked question',
    'Return and exchange policy': 'Return and exchange policy',
    'Shipping and distribution': 'Shipping and distribution',
    'Contact us by email': 'Contact us by email',
    'Privacy Policy and Terms of Use': 'Privacy Policy and Terms of Use',
    'Privacy Policy': 'Privacy Policy',
    'Terms of use': 'Terms of use',
    'Upload credentials': 'Upload credentials',
    'The withdrawal is being processed': 'The withdrawal is being processed',
    'Cause of failure': 'Cause of failure',
    'Your shopping cart is still empty': 'Your shopping cart is still empty',
    'Log in to view the items in your cart': 'Log in to view the items in your cart',
    'Browse around': 'Browse around',
    'Account correlation': 'Account correlation',
    'Order management': 'Order management',
    'Payment method': 'Payment method',
    'Collection address': 'Collection address',
    'Amazon GIFT CARD': 'Amazon GIFT CARD',
    'High Priced Recycling': 'High Priced Recycling',
    'Data': 'Data',
    'congratulations': 'congratulations',
    'Obtain': 'Obtain',
    'ThankYouForParticipating': 'Thank You for Participating',

    // navbar
    Home: 'Home',
    Category: 'Category',
    Search: 'Search',
    ShoppingCart: 'Shopping Cart',
    Mine: 'Mine',

    "MyCommission": "My Commission",
    "Gross income": "Gross income",
    "Direct commission": "Direct commission",
    "Indirect commission": "Indirect commission",
    "Transfer to wallet": "Transfer to wallet",
    "Tip: The transfer amount must be greater than 10USDT": "Tip: The transfer amount must be greater than 10USDT",
    "transfer": "transfer",
    "commission": "commission",
    "Please enter": "Please enter",

    // 首页
    // 搜索
    EnterSearchContent: 'Enter search content',
    'Recent searches': 'Recent searches',
    'popular searches': 'popular searches',
    'Please search': 'Please enter the keyword you want to search',
    'orderSearch': 'Enter the name of the order or product to search',

    // 语言
    'Language selection': 'Language selection',

    // menu
    Brand: 'Brand',
    Collect: 'Collect',
    Manage: 'Manage',
    Order: 'Order',
    Wallet: 'Wallet',
    BlindBox: 'Blind box',
    MenuGiftCard: 'Gift card',
    // HotSale
    HotSale: 'The latest news is in hot sale...',
    // tabs
    TodaysOffer: "Platform Preferred",
    'Phone': "Phone",
    'Smart Watch': "Smart Watch",
    'Smart bracelet': "Smart bracelet",

    // gobuy
    'home.gobuy.title': 'Meet a big surprise',
    'home.gobuy.periods': 'Blind Box Round',
    'home.gobuy.freeze': 'Join the countdown',
    'home.gobuy.drawing': 'Start the countdown',
    'home.gobuy.buy': 'Participate in',
    'home.gobuy.isbuy': 'Participated',
    USDT: 'USDT',
    'home.gobuy.jackpot': 'Bonus pool',
    Purse: 'Purse',
    Box: 'Box',
    'GetAPrize': 'Get a prize',
    Discount: 'Discount',
    when: 'when',
    points: 'points',
    seconds: 'seconds',
    // MessageBox
    'MessageBox.Tips': 'Tips',
    'MessageBox.Confirm': 'Confirm',
    'MessageBox.Cancel': 'Cancel',
    'MessageBox.buy.box': 'Are you sure to buy this blind box?',
    // Toast
    'succ': 'Success',
    'err': 'Error',
    'box.succeeds': 'purchase succeeds',
    'box.frozen': 'Already Participated',
    'box.issue': 'You can only buy one blind box per issue',

    // 商品列表
    filter: 'Filter',
    sales: 'Sales',
    selfOP: 'Self-operated',
    noMore: 'No more',
    brand: 'Brand',
    confirm: 'Confirm',
    reset: 'Reset',
    ComSor: 'Comprehensive Sorting',
    MostPop: 'Most Popular',
    HighLow: 'Price High to Low',
    LowHigh: 'Price Low to High',
    SalVol: 'Sales Volume',
    NewArr: 'New Arrivals',

    // 购物车
    'cart.cart': 'Shopping Cart',
    'cart.edit': 'Edit',
    'cart.done': 'Done',
    'home.cart.voucher': 'Get Coupons',
    'home.cart.outstock': 'Out of Stock',
    'home.cart.offshelf': 'Off the Shelf',
    'Only': 'Only',
    'left': 'left',
    'Promotion': 'Promotion',
    'cart.all': 'Select All',
    'cart.total': 'Total',
    'cart.delete': 'Delete',
    'cart.checkout': 'Checkout',

    // 我的
    'Direct': 'Direct',
    'Indirect': 'Indirect',
    'MyOrders': 'My Orders',
    'ViewAll': 'View All',
    'Unpaid': 'Unpaid',
    'ToShip': 'To Ship',
    'ToReceive': 'To Receive',
    'ToReview': 'To Review',
    // 盲盒
    'MyBlindBox': 'Blind Box List',
    'WaitingDraw': 'Waiting for Draw',
    'Opened': 'Opened (Pick Up/Return)',
    // 礼品卡
    'After sale': 'After sale',
    'GiftCard': 'Gift Card List',
    'RecycleGiftCard': 'Recycle Gift',
    'Verifying': 'Under Verification',
    'Rebuying': 'Buyback in Progress',
    'Repurchased': 'Pending Payment',
    'Paid': 'Payment Made',
    // 常用工具
    'CommonTools': 'Common Tools',
    'MyWallet': 'My Wallet',
    'VirtualOrders': 'Virtual Orders',
    'Refunds': 'Refunds',
    'MyFriends': 'My Friends',
    'ChatList': 'Chat List',
    'RealNameVerification': 'Real Name Verification',
    'MyFavorites': 'My Favorites',
    'Addresses': 'Addresses',
    'MyReviews': 'My Reviews',
    'BrowsingHistory': 'Browsing',
    'Promotions': 'Promotions',
    'StoreManagement': 'Store Management',
    'BecomeASeller': 'Become a Seller',

    // order list
    'SearchPlaceholder': 'Enter Order Item Name to Search',
    All: 'All',
    OrderNo: 'Order No.',
    items: 'items',
    ShippingFee: 'Shipping Fee',
    'Refund in Progress': 'Refund in Progress',
    'Cancel Order': 'Cancel Order',
    'Refund': 'Refund',
    'Track Shipping': 'Track Shipping',
    'Confirm Receipt': 'Confirm Receipt',
    'Evaluate': 'Evaluate',
    'Delete': 'Delete',
    'Pay': 'Pay',
    'MessageBox.delete.order': 'Are you sure you want to delete this order?',
    'MessageBox.cancel.order': 'Are you sure you want to cancel this order?',
    'MessageBox.receive.order': 'Has this order been received?',
    // detail
    'Order Details': 'Order Details',
    'Pickup Code': 'Pickup Code',
    'Complaint': 'Complaint',
    'After-Sales': 'After-Sales',
    'Gift': 'Gift',
    'Order Date': 'Order Date',
    'Used voucher worth': 'Used voucher worth',
    'CNY': 'CNY',
    'Payment Method': 'Payment Method',
    'Total Product Amount': 'Total Product Amount',
    'Shipping Fee': 'Shipping Fee',
    'Amount Paid': 'Amount Paid',
    'Return': 'Return',
    // 盲盒list
    'Pending Draw': 'Pending Draw',
    'Pending Unboxing': 'Pending Unboxing',
    'Unboxed': 'Unboxed',
    'Collected': 'Collected',
    'Recycled': 'Recycled',
    'Unknown': 'Unknown',
    'Claim': 'Claim',
    'Recycle': 'Buyback',
    'Unbox': 'Unbox',
    'MessageBox.recycle.box': 'Are you sure you want to recycle this mystery box?',
    // 盲盒detail
    'Mystery Box Details': 'Mystery Box Details',
    'Unopened': 'Unopened',
    'box.opened': 'Unopened',
    'Claimed': 'Claimed',
    'Confirm Claim': 'Confirm Claim',
    'MessageBox.pick.box': 'Are you sure you want to pick up this blind box?',
    // 盲盒提货
    'Please add address': 'Please add address',
    // 礼品卡list
    'Face Value Total': 'Face Value Total',
    // 礼品卡detail
    'Gift Card Details': 'Gift Card Details',
    'Card number': 'Card number',
    'Activation code': 'Activation code',
    'Actual recovery price': 'Actual recovery price',
    // 礼品卡回收
    'Gift Card Recycling': 'Gift Card Recycling',
    'Confirm Recycling': 'Confirm Recycling',
    'Please enter the card number': 'Please enter the card number',
    'Please enter the activation code': 'Please enter the activation code',
    'MessageBox.recycle.gift': 'Are you sure you want to recycle this gift card?',

    // 我的钱包
    'My Wallet': 'My Wallet',
    'Available Balance': 'Available Balance',
    'Frozen Funds': 'Frozen Funds',
    'Recharge': 'Top-up',
    "can": "Can",
    'Withdraw': 'Withdraw',
    'Withdrawal Accounts': 'Withdrawal Accounts',
    // 充值
    'Recharge Details': 'Recharge Details',
    'Recharge Order No.': 'Recharge Order No.',
    'Recharge Amount': 'Recharge Amount',
    'Creation Time': 'Creation Time',
    'MessageBox.recharge.pop': 'Please enter the recharge amount',
    // 付款
    'payment': 'payment',
    'Order submitted successfully, please select payment method': 'Order submitted successfully, please select payment method',
    'Rechargeable card': 'Rechargeable card',
    'Please enter a hash': 'Please enter a hash',
    'Immediate payment': 'Immediate payment',
    'Wait for the file to load': 'Wait for the file to load',
    // 提现
    'Withdrawal Details': 'Withdrawal Details',
    'Withdrawal Amount': 'Withdrawal Amount',
    'Application Time': 'Application Time',
    'New Application': 'New Application',
    'Payment Password': 'Payment Password',
    'New Payment Password': 'New Payment Password',
    'Recipient Information': 'Recipient Information',
    'Submit': 'Submit',
    'Add Recipient Account First': 'Add Recipient Account First',
    'Please bind your mobile phone or email first': 'Please bind your mobile phone or email first',
    // 设置
    'Account Settings': 'Account Settings',
    'Change Login Password': 'Change Login Password',
    'Change Payment Password': 'Change Payment Password',
    'Log Out': 'Log Out',
    'Mobile': 'Mobile',
    'Verification Code': 'Verification Code',
    'Email': 'Email',
    'Old Password': 'Old Password',
    'New Password': 'New Password',
    'Confirm Password': 'Confirm Password',
    'Modify': 'Modify',
    'Bind': 'Bind',
    ' Mobile': ' Mobile',
    ' Email': ' Email',
    // 资金详情
    'Fund Details': 'Record History',
    // 提现账号
    'Withdrawal Account': 'Withdrawal Account',
    'Account Type': 'Account Type',
    'USDT Address (TRC20)': 'USDT Address (TRC20)',
    'Edit': 'Edit',
    'Delete': 'Delete',
    'Add New': 'Add New',
    'MessageBox.delete.bank': 'Are you sure you want to delete this withdrawal account?',

    // Login
    Login: 'Login',
    'Sign Up': 'Sign Up',
    'Normal Login': 'Normal Login',
    'Username / Email / Phone Number': 'Username / Email',
    'Enter Phone Number': 'Enter Phone Number',
    'Enter Email': 'Enter Email',
    'Enter SMS Code': 'Enter SMS Code',
    'Enter Password': 'Enter Password',
    "enter_login_password_for_verification": "Please enter your login password for verification",
    'Forgot Password': 'Forgot Password',
    'Third-party Login': 'Third-party Login',
    'Please complete the form': 'Please complete the form',
    'WeChat': 'WeChat',
    'Weibo': 'Weibo',
    'QQ': 'QQ',
    'phone login': 'phone login',
    'Login Expired': 'Login Expired',
    'Please enter your phone number first': 'Please enter your phone number first',
    'Please enter your username/email/phone number': 'Please enter your username/email',
    'Please enter your password': 'Please enter your password',
    'Password must be at least 6 characters': 'Password must be at least 6 characters',
    'Please enter an 11-digit phone number': 'Please enter an 11-digit phone number',
    'Please wait for the file to finish loading': 'Please wait for the file to finish loading',
    'send': 'send',
    'signUpTips': 'Your personal data will be used to support your experience throughout the site, to manage access to your account, and for other purposes described in our privacy policy.',
    // Sign Up
    'Sign Up': 'Sign Up',
    'Referrer': 'Referrer',
    'Invitation code': 'Invitation code',
    'Invite friends': 'Invite Friends',
    'Username': 'Username',
    'Full Name': 'Real name',
    'Set Password': 'Set Password',
    'Change password': 'Change password',
    'Confirm Password': 'Confirm Password',
    'Phone Number': 'Phone Number',
    'Email': 'Email',
    'Username: 3-25 chars, letters & numbers': 'Username: 3-25 chars, letters & numbers',
    '6-20 digits/letters/symbols': '6-20 digits/letters/symbols',
    'By clicking sign up, you agree to': 'By clicking sign up, you agree to',
    'User Agreement': 'User Agreement',
    'Please check the user agreement': 'Please check the user agreement',
    'Please enter a username with 3-25 characters': 'Please enter a username with 3-25 characters',
    'Enter SMS Verification Code': 'Enter SMS Verification Code',
    'Please enter your phone number': 'Please enter your phone number',
    'Please enter the verification code': 'Please enter the verification code',
    'Please enter a 6-digit verification code': 'Please enter a 6-digit verification code',
    'Please enter a password with 6-20 characters': 'Please enter a password with 6-20 characters',
    'Please enter the confirm password': 'Please enter the confirm password',
    'The confirm password does not match the entered password': 'The confirm password does not match the entered password',
    // Password Recovery
    'Password Recovery': 'Password Recovery',
    'Forgot Password': 'Forgot Password',
    'Forget.email.tips': 'If your account has not yet been linked to a email number, please contact the platform administrator to recover your password.',

    // Notification 通知消息
    'Notification Message': 'Notification Message',
    'Direct Message': 'Direct Message',
    'System Message': 'System Message',
    'Leave a Message': 'Leave a Message',

    // Delivery address 配送地址
    'Delivery Address': 'Delivery Address',
    'The store is no longer valid, please edit the delivery address again': 'The store is no longer valid, please edit the delivery address again',
    'Default address': 'Default address',
    'Add address': 'Add address',
    'Edit address': 'Edit address',
    'MessageBox.delete.address': 'Are you sure you want to delete this address?',
    'name': 'name',
    'phone': 'phone',
    'district': 'district',
    'address': 'address',
    'default address': 'default address',
    'save and use': 'save and use',
    'save': 'save',
    'Please select a region': 'Please select a region',
    'Please fill in the recipient name': 'Please fill in the recipient name',
    'Name must be 2-15 characters': 'Name must be 2-15 characters',
    'Please fill in the mobile phone number': 'Please fill in the mobile phone number',
    'Please select your location': 'Please select your location',
    'Please fill in the detailed address': 'Please fill in the detailed address',

    //Browsing history 浏览历史
    'Browsing History': 'Browsing History',
    'Clear browsing history': 'Clear History',

    // inviter 推广会员
    'Promotion member': 'Promotion member',
    "“PromotionPoster”": "Promotion Poster",
    "MemberName": "Member Name",
    "MyAssets": "My Assets",
    "DistributedAmount": "Distributed Amount",
    "NumberOfDistributedProducts": "Distributed Products",
    "DistributedProductAmount": "Distributed Amount",
    "MyTeam": "My Team",
    "LevelOneMembers": "Level 1 Members",
    "LevelTwoMembers": "Level 2 Members",
    "PromotionPoster": "Promotion Poster",
    "PromotionMembers": "Promotion Members",
    "PromotionPerformance": "Promotion Performance",
    "ViewPromotionLink": "Click to View Promotion Link",
    "PromoteViaWeChatQRCode": "Promote via WeChat QR Code",
    "Copy": "Copy",
    "BrowserNotSupportedCopyManually": "Your browser does not support direct copying; please copy manually",
    'GiftCardRecoveryTotal': 'Gift Card Recovery Total',
    'TodaysGiftCardRecoveryCount': 'Today\'s Gift Card Recovery Count',
    'RegistrationDate': 'Registration Date',
    'LastLogin': 'Last Login',
    'Promotion Commission': 'Promotion Commission',

    // userinfo 个人信息
    'Personal Info': 'Personal Info',
    Nickname: 'Nickname',
    Birthdate: 'Birthdate',
    Save: 'Save',
    CropImage: 'Crop Image',
    UseImage: 'Use Image',

    // goodsDetail 商品详情
    Off: 'Off',
    Sold: 'Sold',
    Product: 'Product',
    Comment: 'Comment',
    Details: 'Details',
    ReportViolation: 'Report',
    Cart: 'Cart',
    ChatMessages: 'Chat Messages',
    MyShop: 'My Shop',
    MerchantLogin: 'Merchant Login',
    Share: 'Share',
    ShareTo: 'Share To',
    WeChat: 'WeChat',
    Copy: 'Copy',
    Poster: 'Poster',
    BrowserNotSupportedCopyManually: 'Your browser does not support direct copying; please copy manually',
    Follow: 'Follow',
    Unfollow: 'Unfollow',
    PleaseSelectQuantityAndCategory: 'Please select the quantity and category.',
    SelectedWithQuantity1: 'Selected {specification}, quantity {number}.',
    SelectedQuantity1: 'Selected quantity {number}.',
    SelectedWithQuantity2: 'Selected {specification}, quantity {number}.',
    'Add to cart': 'Add to cart',
    'Buy now': 'Buy now',
    Stock: 'Stock ',
    Pieces: ' pieces',
    Quantity: 'Quantity ',
    All: 'All',
    Good: 'Good Review',
    Medium: 'Medium Review',
    Bad: 'Bad Review',
    // 评论
    'Product review': 'Product review',
    anonymous: 'Anonymous',
    noReviewInfo: 'No review information provided',
    'Shop Owners Response': 'Shop Owner\'s Response',
    'This product has no current reviews': 'This product has no current reviews',
    'Product details': 'Product details',
    shop: 'Shop',
    customerService: 'Customer Service',
    shoppingCart: 'Shopping Cart',
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
    outOfStock: 'The selected product is currently out of stock, we apologize!',
    notAvailable: 'The selected product is no longer available, we apologize!',
    'Store order message': 'Store order message',
    'Confirm the order': 'Confirm the order',
    productAmount: 'Product Amount',
    discount: 'Discount',
    shippingFee: 'Shipping Fee',
    subtotal: 'Subtotal for Store',
    'Submit an order': 'Submit an order',
    // 退货
    refundAdd: 'Add Refund',
    back: 'Back',
    refundDescription: 'Refund Description:',
    proofOfRefund: 'Proof of Refund',
    use: 'Use',
}
export default en
